// Mother Campaign (PAD-33370/PAD-33470): the API refuses a child ADM campaign id for its own client
// with extensions { code: MOTHER_CAMPAIGN_REDIRECT, motherCampaignId }; the builder opens the mother.
// Plain JS (no imports) so scripts/test-mother-campaign-redirect.mjs can stage and run it.

export const MOTHER_CAMPAIGN_REDIRECT = "MOTHER_CAMPAIGN_REDIRECT";

export const motherCampaignIdOf = (error) => {
  const extensions = error && error.extensions;
  if (!extensions || extensions.code !== MOTHER_CAMPAIGN_REDIRECT) return null;
  const id = Number(extensions.motherCampaignId);
  return Number.isSafeInteger(id) && id > 0 ? String(id) : null;
};

// Same builder page on the mother: /client/832/campaign/10016/builder → /client/832/campaign/9720/builder
export const motherRedirectPath = (pathname, campaignId, motherId) =>
  pathname.replace(new RegExp(`/campaign/${String(campaignId).replace(/\D/g, "")}(?=/|$)`), `/campaign/${motherId}`);
